module.exports = __webpack_public_path__ + "img/qr-icon.51867945.svg";